'use client'

import { ContactBtn } from '@/components/button/contact-btn'
import insideBg from 'images/home/footer_bg.png'
import { ArrowIcon } from 'modules/components'
import { InsideList } from 'modules/constant'
import { motion } from 'framer-motion'
import Image from 'next/image'
import { useState } from 'react'
import { TrackerProvider, TrackExposure, TrackHomeSection } from 'modules/analysis'

const list = InsideList.slice(0, 6)

export function Inside() {
  const [active, setActive] = useState<number[]>([0])

  const onClick = (idx: number) => {
    if (active.includes(idx)) {
      setActive([])
    } else {
      setActive([idx])
    }
  }
  return (
    <div className="section-content mb-38 relative">
      <Image src={insideBg} alt="inside_bg" className="-bottom-39 absolute -left-[25%] h-auto w-[80%]" />
      {list.map(({ question, answer, withContact }, index) => (
        <div
          key={index}
          className="relative float-right mb-2 w-[60%] shrink-0 overflow-hidden rounded-xl bg-white p-9 text-black"
        >
          <TrackerProvider config={{ sectionName: TrackHomeSection.FAQ, attr: { aqId: index, aqPosition: index } }}>
            <TrackExposure config={{ attr: { type: 'title' } }} withClick>
              <div
                className="flex-x-center cursor-pointer justify-between text-2xl font-medium"
                onClick={() => onClick(index)}
              >
                {question}
                <ArrowIcon active={active.includes(index)} className="ml-6 text-[#252525]" from="bottom" to="top" />
              </div>
            </TrackExposure>
            <motion.div
              initial={false}
              animate={{
                height: active.includes(index) ? 'auto' : 0,
                opacity: active.includes(index) ? 1 : 0,
              }}
              transition={{ duration: 0.5 }}
              className="overflow-hidden text-[#333]"
            >
              <TrackExposure config={{ attr: { type: 'content' } }} key="content">
                <div>
                  {answer?.map((item, index) => (
                    <p key={index} className="mb-[0.5em] first:mt-6 last:mb-0">
                      {item}
                    </p>
                  ))}
                </div>
              </TrackExposure>
              {withContact && <ContactBtn className="mt-10" />}
            </motion.div>
          </TrackerProvider>
        </div>
      ))}
    </div>
  )
}
